// extracted by mini-css-extract-plugin
export var arrow = "LinkButton-module--arrow--91e18";
export var arrowIcon = "LinkButton-module--arrowIcon--5664f";
export var bordered = "LinkButton-module--bordered--06dfb";
export var button = "LinkButton-module--button--3ce14";
export var buttonCenter = "LinkButton-module--buttonCenter--be159";
export var buttonContent = "LinkButton-module--buttonContent--fd61b";
export var disabled = "LinkButton-module--disabled--e85ff";
export var visuallyHidden = "LinkButton-module--visuallyHidden--0ac96";